import { Link } from "@remix-run/react";
import { removeSnakeCase } from "app/utils/fn";
import React from "react";
import { HiChevronRight } from "react-icons/hi2";

export default function Breadcrumb({
  category,
  subCategory,
  productOverview,
}: {
  category?: string;
  subCategory?: string;
  productOverview: { name?: string; code?: string };
}) {
  return (
    <div className="w-full overflow-x-auto whitespace-nowrap py-2">
      <div className="flex items-center text-xs md:text-sm gap-1 md:gap-2 text-gray-400">
        <Link to="/" className="text-primary transition-colors">
          Home
        </Link>
        <HiChevronRight size={14} className="text-gray-300" />
        <Link to={`/category/${category}`} className="text-primary transition-colors">
          {category ===
          "office-desk-accessories-&-supplies,-office-pens-&-writing-instruments,-pens-&-writing-instruments"
            ? "Office Desk Accessories"
            : removeSnakeCase(category || "")}
        </Link>
        {subCategory && (
          <>
            <HiChevronRight size={14} className="text-gray-300" />
            <Link
              to={`/category/${category}/${subCategory}`}
              className="text-primary transition-colors capitalize"
            >
              {removeSnakeCase(subCategory || "")}
            </Link>
          </>
        )}
        <HiChevronRight size={14} className="text-gray-300" />
        <span className="text-gray-600 font-medium truncate max-w-[200px] md:max-w-none">
          {productOverview?.name}
        </span>
      </div>
    </div>
  );
}
